import { render, staticRenderFns } from "./NoResultsCard.vue?vue&type=template&id=2f7e09e4&"
import script from "./NoResultsCard.vue?vue&type=script&lang=js&"
export * from "./NoResultsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports